/**
 * Boton "Comprar por WhatsApp" del carrito (Majuri).
 *
 * Horizon vuelve a pintar el carrito con morphSection(), o sea que el HTML del
 * drawer se reemplaza en cada cambio y los <script> que vengan dentro de esa
 * respuesta NO se ejecutan (salen de un DOMParser). Por eso el listener se
 * registra una sola vez sobre document, por delegacion: sobrevive a cualquier
 * re-render sin depender de reenganchar nada, y tambien funciona cuando el
 * carrito empieza vacio y el boton aparece despues.
 */
(function () {
  if (window.majuriWhatsappCartReady) return;
  window.majuriWhatsappCartReady = true;

  var SELECTOR = '.majuri-wa-button';
  var DEFAULT_MONEY_FORMAT = 'S/ {{amount}}';

  /**
   * Replica el filtro `money` de Liquid para el formato de la tienda.
   * @param {number} cents
   * @param {string} format
   * @returns {string}
   */
  function formatMoney(cents, format) {
    var moneyFormat = format || DEFAULT_MONEY_FORMAT;
    var value = (typeof cents === 'number' ? cents : 0) / 100;

    function withSeparators(decimals, thousands, decimalPlaces) {
      var fixed = value.toFixed(decimalPlaces);
      var parts = fixed.split('.');
      var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimalPlaces > 0 ? integer + decimals + parts[1] : integer;
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, placeholder) {
      switch (placeholder) {
        case 'amount_no_decimals':
          return withSeparators('.', ',', 0);
        case 'amount_with_comma_separator':
          return withSeparators(',', '.', 2);
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(',', '.', 0);
        case 'amount_with_apostrophe_separator':
          return withSeparators('.', "'", 2);
        case 'amount_with_space_separator':
          return withSeparators(',', ' ', 2);
        case 'amount_no_decimals_with_space_separator':
          return withSeparators(',', ' ', 0);
        default:
          return withSeparators('.', ',', 2);
      }
    });
  }

  /**
   * @param {{ items: Array<Object>, total_price: number, item_count: number }} cart
   * @param {number} shippingCents - Tarifa plana de envio, en centimos.
   * @param {number} thresholdCents - Subtotal desde el que el envio es gratis.
   * @param {string} moneyFormat - shop.money_format, para no inventar la moneda.
   * @returns {string}
   */
  function buildMessage(cart, shippingCents, thresholdCents, moneyFormat) {
    function soles(cents) {
      return formatMoney(cents, moneyFormat);
    }

    var subtotal = cart.total_price;
    var isFree = subtotal >= thresholdCents;
    var shipping = isFree ? 0 : shippingCents;
    var total = subtotal + shipping;

    var lines = [];
    lines.push('Hola, quiero hacer este pedido desde majuri.pe:');
    lines.push('');

    cart.items.forEach(function (item) {
      var name = item.product_title;
      if (item.variant_title && item.variant_title !== 'Default Title') {
        name += ' - ' + item.variant_title;
      }
      lines.push(item.quantity + 'x ' + name + ' — ' + soles(item.final_line_price));
    });

    lines.push('');
    lines.push('Subtotal: ' + soles(subtotal));
    lines.push('Envío: ' + (isFree ? 'Gratis' : soles(shipping)));
    // Los asteriscos son la negrita de WhatsApp y sobreviven a encodeURIComponent.
    lines.push('*Total: ' + soles(total) + '*');

    return lines.join('\n');
  }

  /**
   * @param {MouseEvent} event
   */
  function handleClick(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest(SELECTOR) : null;
    if (!button) return;

    var number = (button.getAttribute('data-wa-number') || '').replace(/\D/g, '');
    if (!number) return;

    var moneyFormat = button.getAttribute('data-money-format');

    // Los data attributes vienen en soles; el carrito trabaja en centimos.
    var shippingCents = Math.round(parseFloat(button.getAttribute('data-wa-shipping') || '0') * 100);
    var thresholdCents = Math.round(parseFloat(button.getAttribute('data-wa-threshold') || '0') * 100);

    // La pestana se abre aqui, dentro del gesto del usuario. Si se abriera al
    // resolver el fetch, Safari en iOS la bloquearia como popup.
    var waWindow = window.open('', '_blank');

    button.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        button.disabled = false;

        if (!cart.items || cart.items.length === 0) {
          if (waWindow) waWindow.close();
          return;
        }

        // Senal para Meta: no es una compra, pero evita quedarse ciego.
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'WhatsAppCheckout', {
            value: cart.total_price / 100,
            currency: cart.currency || 'PEN',
            num_items: cart.item_count,
          });
        }

        var message = buildMessage(cart, shippingCents, thresholdCents, moneyFormat);
        var url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);

        if (waWindow && !waWindow.closed) {
          waWindow.location.href = url;
        } else {
          window.location.href = url;
        }
      })
      .catch(function () {
        button.disabled = false;
        if (waWindow) waWindow.close();
      });
  }

  document.addEventListener('click', handleClick);
})();
